import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.RESET_ACTIVATED_CEMODULES](state) {
        state.activatedCEModules = {};
        state.activatedCEModuleIds = [];
    },

    [types.BULK_ADD_ACTIVATED_CEMODULES](state, activatedCEModules) {
        state.activatedCEModuleIds = [];
        state.activatedCEModules = activatedCEModules.reduce((result, cemodule) => {
            result[cemodule.id] = cemodule;
            state.activatedCEModuleIds.push(cemodule.id);

            return result;
        }, {});
    }
    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/activatedCEModules/mutations.js